import * as React from "react";
const SvgToastIconInfo = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={4} fill="#ED2B2B" />
    <path
      d="M10 16.667A6.669 6.669 0 0 0 16.667 10 6.67 6.67 0 0 0 10 3.333 6.67 6.67 0 0 0 3.333 10 6.67 6.67 0 0 0 10 16.667Zm0-10c.367 0 .667.3.667.666V10c0 .367-.3.667-.667.667A.669.669 0 0 1 9.333 10V7.333c0-.366.3-.666.667-.666ZM9.333 12h1.334v1.333H9.333V12Z"
      fill="#fff"
    />
  </svg>
);
export default SvgToastIconInfo;
